/**
 * api统一出口
 *  将api接口根据功能划分为多个模块，利于多人开发，一个人负责一个模块的开发，方便每个模块中接口的命名
 * */

// 网站管理接口
import websiteManageAPI from "@/api/websiteManageAPI";
// 文件管理接口
import fileManageAPI from "@/api/fileManageAPI";
// 消息列表接口
import messageListAPI from "@/api/messageListAPI";

//首页数据接口
import dashboardAPI from "@/api/dashboardAPI";
//系统管理接口
import systemManageAPI from "@/api/systemManageAPI";
//发布管理接口
import publishManageAPI from "@/api/publishManageAPI";
//作业管理接口
import jobManageAPI from "@/api/jobManageAPI";
//资产管理接口
import assetManageAPI from "@/api/assetManageAPI";
//许可管理接口
import licenseManageAPI from "@/api/licenseManageAPI";
//需求管理接口
import requireManageAPI from "@/api/requireManageAPI";
//社区接口
import formsAPI from "@/api/formsAPI";
//报表接口
import reportManageAPI from "@/api/reportManageAPI";
//投票接口
import voteAPI from "@/api/voteAPI";
import digitalDictManageAPI from "@/api/digitalDictManageAPI";
import newRequireManageAPI from "@/api/newRequireManageAPI";
import newPublishManageAPI from "@/api/newPublishManageAPI";
import componentManageAPI from "@/api/componentManageAPI";
import dEmpAPI from "@/api/dEmpAPI";
import courseManageAPI from "@/api/courseManageAPI";
import psyManageAPI from "./psyManageAPI";
import skillManageAPI from "@/api/skillManageAPI";

// 导出接口
export default {
    websiteManageAPI,
    fileManageAPI,
    messageListAPI,
    dashboardAPI,
    systemManageAPI,
    publishManageAPI,
    jobManageAPI,
    assetManageAPI,
    licenseManageAPI,
    requireManageAPI,
    formsAPI,
    reportManageAPI,
    voteAPI,
    digitalDictManageAPI,
    newRequireManageAPI,
    newPublishManageAPI,
    componentManageAPI,
    dEmpAPI,
    courseManageAPI,
    psyManageAPI,
    skillManageAPI,
};
